import ArrowRight from '@lib/core/src/assets/buttons-icons/arrow-right.svg?react';
import ImagePlaceHolder from '@lib/core/src/assets/meeting-cards/placeholder-journey-meeting.png';
import palette from '@lib/core/src/theme/palette';
import { Box, Stack, styled, Typography, alpha } from '@mui/material';

interface ImageProps {
  imageUrl?: string;
}

export const ArrowRightIcon = styled(ArrowRight)({
  position: 'absolute',
  right: 16,
  top: '50%',
  transform: 'translateY(-50%)',
  opacity: 0,
  transition: 'opacity 0.2s',
  pointerEvents: 'none'
});

export const Container = styled(Stack)({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  padding: '8px 0',
  borderBottom: `2px solid ${palette.grey[300]}`,
  gap: '8px',
  cursor: 'pointer',
  position: 'relative',
  '&:hover': {
    backgroundColor: alpha(palette.black, 0.01)
  },
  '&:hover .arrow-right-icon': {
    opacity: 1
  }
});

export const ImageContainer = styled(Box)({
  position: 'relative',
  width: '56px',
  height: '56px'
});

export const Image = styled(Box, {
  shouldForwardProp: prop => prop !== 'imageUrl'
})<ImageProps>(({ imageUrl }) => ({
  width: '100%',
  height: '100%',
  backgroundColor: palette.black,
  backgroundImage: `url(${imageUrl}), url(${ImagePlaceHolder})`,
  backgroundSize: 'contain',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  borderRadius: '4px'
}));

export const TextContainer = styled(Stack)({
  flexGrow: 1
});

export const Title = styled(Typography)({
  fontSize: '13px'
});

export const SubTitle = styled(Typography)({
  fontSize: '11px',
  color: palette.grey[400]
});
